<div class="page-container">
  <div class="table-container mt-4">
    <table class="custom-table">
      <thead>
        <tr>
          <th>Sr.No</th>
          <th>Bank Name</th>
          <th>Account Number</th>
          <th>Account Holder Name</th>
          <th>IFSC Code</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let bank of filteredBankDetails">
          <td class="fw-bold">{{ bank.srNo }}</td>
          <td>{{ bank.bankName }}</td>
          <td>{{ bank.accountNumber }}</td>
          <td>{{ bank.accountHolderName }}</td>
          <td>{{ bank.ifscCode }}</td>
          <td>
            <span
              class="badge"
              [ngClass]="{
                'badge-success': bank.status === 'Approved',
                'badge-warning': bank.status === 'Pending',
                'badge-danger': bank.status === 'Rejected',
              }"
            >
              {{ bank.status }}
            </span>
          </td>
        </tr>
        <tr *ngIf="filteredBankDetails.length === 0">
          <td colspan="6" class="text-center py-4 text-muted">No bank details found.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="section-header-flex mt-5 mb-3">
    <h2 class="section-title m-0">Withdraw Amount</h2>
    <button class="btn-dark" (click)="openWithdrawModal()">
      <i class="fa-solid fa-money-bill-transfer me-1"></i> Withdrawal Request
    </button>
  </div>

  <div class="table-container">
    <table class="custom-table">
      <thead>
        <tr>
          <th>Sr.No</th>
          <th>Withdraw Amount</th>
          <th>Request Date</th>
          <th>Withdrawal Date</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of filteredWithdrawals">
          <td class="fw-bold">{{ item.srNo }}</td>
          <td class="fw-bold text-success">₹{{ item.amount | number: '1.0-2' }}</td>
          <td>{{ item.requestDate }}</td>
          <td>{{ item.withdrawalDate }}</td>
          <td>
            <span
              class="badge"
              [ngClass]="{
                'badge-success': item.status === 'Delivered',
                'badge-warning': item.status === 'Requested',
                'badge-danger': item.status === 'Rejected',
              }"
            >
              {{ item.status }}
            </span>
          </td>
        </tr>
        <tr *ngIf="filteredWithdrawals.length === 0">
          <td colspan="5" class="text-center py-4 text-muted">No withdrawal history found.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="modal-overlay" *ngIf="isModalOpen">
    <div class="modal-content">
      <div class="modal-header">
        <h2>Add Bank</h2>
        <i class="fa-solid fa-xmark close-icon" (click)="closeModal()"></i>
      </div>
      <form [formGroup]="bankForm" class="modal-body">
        <div class="form-group">
          <label>Bank Name</label>
          <div
            class="input-with-icon"
            [ngClass]="{ 'has-error': isFieldInvalid(bankForm, 'bankName') }"
          >
            <i class="fa-regular fa-building icon"></i>
            <input
              type="text"
              formControlName="bankName"
              class="custom-input has-icon"
              placeholder="Enter Bank Name"
            />
          </div>
          <span class="error-text" *ngIf="isFieldInvalid(bankForm, 'bankName')"
            >Please enter a valid bank name (letters only).</span
          >
        </div>
        <div class="form-group">
          <label>Account Number</label>
          <div
            class="input-with-icon"
            [ngClass]="{ 'has-error': isFieldInvalid(bankForm, 'accountNumber') }"
          >
            <i class="fa-solid fa-money-check icon"></i>
            <input
              type="text"
              formControlName="accountNumber"
              class="custom-input has-icon"
              placeholder="Enter Account Number"
              maxlength="18"
            />
          </div>
          <span class="error-text" *ngIf="isFieldInvalid(bankForm, 'accountNumber')"
            >Enter a valid account number (9 to 18 digits).</span
          >
        </div>
        <div class="form-group">
          <label>Account Holder Name</label>
          <div
            class="input-with-icon"
            [ngClass]="{ 'has-error': isFieldInvalid(bankForm, 'accountHolderName') }"
          >
            <i class="fa-solid fa-user icon"></i>
            <input
              type="text"
              formControlName="accountHolderName"
              class="custom-input has-icon"
              placeholder="Enter Account Holder Name"
            />
          </div>
          <span class="error-text" *ngIf="isFieldInvalid(bankForm, 'accountHolderName')"
            >Account holder name is required (letters only).</span
          >
        </div>
        <div class="form-group">
          <label>IFSC Code</label>
          <div
            class="input-with-icon"
            [ngClass]="{ 'has-error': isFieldInvalid(bankForm, 'ifscCode') }"
          >
            <i class="fa-solid fa-building-columns icon"></i>
            <input
              type="text"
              formControlName="ifscCode"
              class="custom-input has-icon"
              placeholder="e.g. HDFC0001285"
              style="text-transform: uppercase"
              maxlength="11"
            />
          </div>
          <span class="error-text" *ngIf="isFieldInvalid(bankForm, 'ifscCode')"
            >Enter a valid 11-character IFSC Code.</span
          >
        </div>
      </form>
      <div class="modal-footer">
        <button class="btn-dark full-width-btn" (click)="saveBank()">Save</button>
      </div>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="isWithdrawModalOpen">
    <div class="modal-content">
      <div class="modal-header">
        <h2>Withdrawal Request</h2>
        <i class="fa-solid fa-xmark close-icon" (click)="closeWithdrawModal()"></i>
      </div>
      <form [formGroup]="withdrawForm" class="modal-body">
        <div class="form-group">
          <label>Select Bank Account</label>
          <div
            class="input-with-icon"
            [ngClass]="{ 'has-error': isFieldInvalid(withdrawForm, 'bankID') }"
          >
            <i class="fa-solid fa-building-columns icon"></i>
            <select formControlName="bankID" class="custom-input has-icon" style="appearance: auto">
              <option value="" disabled selected>Choose an approved bank...</option>
              <option *ngFor="let bank of approvedBanks" [value]="bank.bankID">
                {{ bank.bankName }} - {{ bank.accountNumber }}
              </option>
            </select>
          </div>
          <span class="error-text" *ngIf="isFieldInvalid(withdrawForm, 'bankID')"
            >Please select a bank.</span
          >
        </div>

        <div class="form-group">
          <label>Amount (Max ₹9,99,999)</label>
          <div
            class="input-with-icon"
            [ngClass]="{ 'has-error': isFieldInvalid(withdrawForm, 'withdrawAmount') }"
          >
            <i class="fa-solid fa-indian-rupee-sign icon"></i>
            <input
              type="number"
              formControlName="withdrawAmount"
              class="custom-input has-icon"
              placeholder="Enter Amount"
              min="1"
              max="999999"
            />
          </div>
          <span class="error-text" *ngIf="isFieldInvalid(withdrawForm, 'withdrawAmount')">
            Enter a valid amount between ₹1 and ₹9,99,999.
          </span>
        </div>
      </form>

      <div class="modal-footer">
        <button class="btn-dark full-width-btn" (click)="submitWithdrawal()">Submit Request</button>
      </div>
    </div>
  </div>
</div>
